(() => {
  if (window.CaffreyArctic) return;
  const state = { busy: false, heroObserver: null, closeObserver: null, pastHero: false, closeVisible: false };
  const q = selector => document.querySelector(selector);
  const text = key => q('[data-ad-root]')?.dataset[key] || '';
  function sticky() {
    q('[data-ad-sticky]')?.classList.toggle('is-visible', state.pastHero && !state.closeVisible && !state.busy);
  }
  function observe() {
    document.documentElement.classList.add('cf-ad-js');
    state.heroObserver?.disconnect();
    state.closeObserver?.disconnect();
    const buy = q('[data-ad-buy]'), close = q('[data-ad-close]');
    if (buy) {
      state.heroObserver = new IntersectionObserver(entries => {
        state.pastHero = !entries[0].isIntersecting && entries[0].boundingClientRect.bottom < 0;
        sticky();
      });
      state.heroObserver.observe(buy);
    }
    if (close) {
      state.closeObserver = new IntersectionObserver(entries => { state.closeVisible = entries[0].isIntersecting; sticky(); });
      state.closeObserver.observe(close);
    }
  }
  function busy(value) {
    state.busy = value;
    document.querySelectorAll('button[data-ad-add]').forEach(button => {
      if (button.dataset.available === 'false') return;
      button.disabled = value;
      button.setAttribute('aria-busy', String(value));
      button.textContent = value ? text('adAdding') : text('adAdd');
    });
    sticky();
  }
  function feedback(message, error = false) {
    const node = q('[data-ad-feedback]');
    if (!node) return;
    node.replaceChildren(document.createTextNode(message));
    node.dataset.error = String(error);
    if (!error) {
      const link = document.createElement('a');
      link.href = window.routes?.cart_url || '/cart';
      link.textContent = text('adViewBag');
      node.append(link);
    }
  }
  function selectPhoto(link) {
    const gallery = link.closest('[data-ad-gallery]');
    const image = gallery?.querySelector('[data-ad-gallery-image]');
    if (!image) return false;
    image.srcset = link.dataset.adSrcset;
    image.src = link.dataset.adSrc;
    image.alt = link.dataset.adAlt;
    gallery.querySelectorAll('[data-ad-gallery-link]').forEach(item => {
      if (item === link) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });
    return true;
  }
  document.addEventListener('click', event => {
    const photo = event.target.closest('[data-ad-gallery-link]');
    if (photo && !event.ctrlKey && !event.metaKey && !event.shiftKey && selectPhoto(photo)) event.preventDefault();
    const step = event.target.closest('[data-ad-quantity-step]');
    if (step) {
      const input = q('#cf-ad-quantity');
      if (!input) return;
      input.value = String(Math.max(1, (Number.parseInt(input.value, 10) || 1) + Number(step.dataset.adQuantityStep)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('keydown', event => {
    const photo = event.target.closest('[data-ad-gallery-link]');
    if (!photo || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
    const links = [...photo.closest('[data-ad-gallery]').querySelectorAll('[data-ad-gallery-link]')];
    let index = links.indexOf(photo);
    if (event.key === 'Home') index = 0;
    else if (event.key === 'End') index = links.length - 1;
    else index = (index + (event.key === 'ArrowRight' ? 1 : -1) + links.length) % links.length;
    event.preventDefault(); selectPhoto(links[index]); links[index].focus();
  });
  document.addEventListener('submit', async event => {
    if (!event.target.matches('[data-ad-form]')) return;
    event.preventDefault();
    if (state.busy || !event.target.reportValidity()) return;
    const form = event.target;
    busy(true);
    const status = q('[data-ad-feedback]');
    if (status) status.textContent = '';
    let requestStarted = false;
    try {
      const data = new FormData(form);
      const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      if (cart?.getSectionsToRender) {
        data.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        data.set('sections_url', window.location.pathname + window.location.search);
        cart.setActiveElement?.(document.activeElement);
      }
      requestStarted = true;
      const response = await fetch((window.routes?.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data });
      const result = await response.json();
      if (!response.ok || result.status) { feedback(result.description || text('adError'), true); return; }
      feedback(text('adAdded'));
      if (cart?.renderContents && result.sections) { cart.classList.remove('is-empty'); cart.renderContents(result); }
      document.dispatchEvent(new CustomEvent('cf:arctic-added', { detail: { variantId: result.variant_id, quantity: result.quantity } }));
    } catch { feedback(requestStarted ? text('adCheckBag') : text('adError'), true); }
    finally { busy(false); }
  });
  document.addEventListener('shopify:section:load', observe);
  document.addEventListener('shopify:section:unload', observe);
  window.CaffreyArctic = { observe };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();
